"use client";
import React, { useState } from "react";
import StyledContainer from "@/components/StyledContainer";
import CenteredTitle from "../components/centered-title";
import PracticeAreaGrid from "../components/practice-area-grid";
import StyledButton from "@/components/StyledButton";

const PracticeArea3 = ({ slice, practiceAreas }) => {
  const [showAll, setShowAll] = useState(false);

  const handleViewAll = () => {
    setShowAll(true);
  };

  practiceAreas.sort(function (a, b) {
    return a?.data?.order - b?.data?.order;
  });

  const practiceAreasToShow = practiceAreas?.slice(
    0,
    showAll ? practiceAreas.length : 6,
  );

  return (
    <StyledContainer
      slice={slice}
      className="md:pt-[60px] xl:pt-[80px] md:pb-[60px] xl:pb-[80px]"
    >
      <div>
        <CenteredTitle
          title={slice?.primary?.title}
          description={slice?.primary?.description}
        />
      </div>

      <div className="md:grid hidden md:grid-cols-3 xl:grid-cols-4 md:gap-x-[20px] md:gap-y-[26px] xl:gap-x-[22px] xl:gap-y-[28px]">
        {practiceAreas?.map((item, idx) => (
          <PracticeAreaGrid key={idx} data={item} />
        ))}
      </div>

      <div className="grid grid-cols-1 md:hidden gap-[26px] max-w-[450px] mx-auto">
        {practiceAreasToShow?.map((item, idx) => (
          <PracticeAreaGrid key={idx} data={item} />
        ))}
      </div>

      {!showAll && (
        <div className="flex justify-center md:hidden mt-[32px]">
          <StyledButton label={"View All"} onClick={handleViewAll} />
        </div>
      )}
    </StyledContainer>
  );
};

export default PracticeArea3;
